export default {"src":"/_next/static/image/public/images/icons4/3.5e01c6ac6910cb8ccdb6c402bf14954e.svg","height":44,"width":44};